import { useState, useEffect } from "react";

export default function FrenchStartupBadge() {
  const [collapsed, setCollapsed] = useState(false); // Start expanded

  // Auto-collapse after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setCollapsed(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    setCollapsed(!collapsed); // Toggle on click
  };

  return (
    <div 
      className="fixed bottom-24 z-40 flex items-center transition-all duration-500 ease-out cursor-pointer"
      style={{ 
        right: collapsed ? -52 : 0
      }}
      onClick={handleClick}
      role="button"
      aria-label="Startup française"
    >
      {/* Small flag tab - always visible */}
      <div className="flex flex-col h-14 w-4 rounded-l-sm overflow-hidden shadow-sm border-y border-l border-slate-300/50 dark:border-slate-600/50 flex-shrink-0">
        <div className="flex-1 bg-blue-600" />
        <div className="flex-1 bg-white" />
        <div className="flex-1 bg-red-500" />
      </div>
      
      {/* Expanded content */}
      <div className="bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm border-y border-r border-slate-300/50 dark:border-slate-600/50 rounded-r-sm shadow-sm">
        <div className="px-2 py-1.5">
          <p className="text-[9px] font-medium text-slate-500 dark:text-slate-400 leading-tight text-center">
            Startup<br/>française
          </p>
        </div>
      </div>
    </div>
  );
}
